import Vue from 'vue'
import VueEvents from 'vue-events'

Vue.use(VueEvents)

// Options can be added to the toasted like css classes to the container
